import { defineComponent as _defineComponent } from 'vue'
import device from '@@/bits/device'
import { useAuthOrgVerificationStore } from '@@/pinia/auth_org_verification_store'
import { goBack } from '@@/bits/location'
import OzBackButton from '@@/library/v4/components/OzBackButton.vue'
import OzContainedButton, { OzContainedButtonColorScheme } from '@@/library/v4/components/OzContainedButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzInput from '@@/library/v4/components/OzInput.vue'
import OzLabelInput from '@@/library/v4/components/OzLabelInput.vue'
import OzPadletLogo from '@@/library/v4/components/OzPadletLogo.vue'
import OzPlainButton, {
  OzPlainButtonColorScheme,
  OzPlainButtonSizePreset,
} from '@@/library/v4/components/OzPlainButton.vue'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import AuthActionMenu from '@@/vuecomponents/AuthActionMenu.vue'
import AuthBottomNav from '@@/vuecomponents/AuthBottomNav.vue'
import { useWindowSizeStore } from '@@/pinia/window_size'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthOrgVerificationApp',
  setup(__props) {

const authOrgVerificationStore = useAuthOrgVerificationStore()
const windowSizeStore = useWindowSizeStore()
const orgDomainInput = ref<InstanceType<typeof OzInput>>()
const xActionMenu = ref(false)
const isInputFocused = ref(false)
const initialScrollY = ref(0)
const isElectronApp = device.electronApp
const isDesktop = device.desktop

const isValid = computed(() => {
  return authOrgVerificationStore.orgDomainValidationMessage.length ? 'no' : 'yes'
})

const isContinueButtonDisabled = computed(() => {
  return !authOrgVerificationStore.orgDomain.length || !!authOrgVerificationStore.orgDomainValidationMessage.length
})

function onInput(e): void {
  authOrgVerificationStore.setOrgDomain(e.target.value)

  // Reset the validation message to enable the Continue button when typing on mobile and tablet
  if (authOrgVerificationStore.orgDomainValidationMessage) authOrgVerificationStore.setOrgDomainValidationMessage('')
}

function onFocusIn(): void {
  isInputFocused.value = true
}

function onBlur(): void {
  isInputFocused.value = false
  document.removeEventListener('scroll', blurInputOnScroll)
}

function blurInputOnScroll(): void {
  // Note: the scroll event is fired when people press a key on the soft keyboard only on iPad
  // we just blur the input only if the user scrolls past a certain threshold
  if (isExceededScrollableThreshold(window.scrollY)) {
    orgDomainInput.value?.blurInput()
  }
}

function isExceededScrollableThreshold(currentWindowY: number): boolean {
  const SCROLLABLE_THRESHOLD = 40 // the height of the input field
  return (
    currentWindowY > initialScrollY.value + SCROLLABLE_THRESHOLD ||
    currentWindowY < initialScrollY.value - SCROLLABLE_THRESHOLD
  )
}

watch(
  () => windowSizeStore.visualViewportHeight,
  (newHeight, oldHeight) => {
    if (isDesktop || !isInputFocused.value) return

    initialScrollY.value = window.scrollY

    // When people focus on the input, the keyboard will pop up
    // so the visual viewport height will be narrowed down.
    // we want to hide the keyboard when people try to scroll the page
    if (newHeight < oldHeight) {
      document.addEventListener('scroll', blurInputOnScroll)
    }
  },
)

watch(
  () => authOrgVerificationStore.isAwaitingServerResponse,
  (value) => {
    const html = document.getElementsByTagName('html')[0]

    // Animate the background color while waiting for the response
    if (value) {
      html.classList.add('dot-grid-loading')
    } else {
      html.classList.remove('dot-grid-loading')
    }
  },
)

onMounted(() => {
  nextTick(() => {
    orgDomainInput.value?.focusInput()
  })
})

return { __sfc: true,authOrgVerificationStore, windowSizeStore, orgDomainInput, xActionMenu, isInputFocused, initialScrollY, isElectronApp, isDesktop, isValid, isContinueButtonDisabled, onInput, onFocusIn, onBlur, blurInputOnScroll, isExceededScrollableThreshold, goBack, OzBackButton, OzContainedButton, OzContainedButtonColorScheme, OzIcon, OzInput, OzLabelInput, OzPadletLogo, OzPlainButton, OzPlainButtonColorScheme, OzPlainButtonSizePreset, AuthActionMenu, AuthBottomNav }
}

})